import React, { useEffect, useState } from "react";

import ClozeSentence from "../ClozeSentence";
import Icon from "../Icon";

const STATUS_LABEL = {
  pending: "Queued",
  queued: "Queued",
  working: "Processing",
  completed: "Completed",
  completed_with_errors: "Completed with errors",
  failed: "Failed"
};

function statusContext(status) {
  if(status === "completed") return "success";
  if(status === "completed_with_errors") return "warning";
  if(status === "failed") return "danger";
  return "info";
}

function ImportDetail({ importBatch }) {
  const [loading, setLoading] = useState(true);
  const [importData, setImportData] = useState(null);

  useEffect(() => {
    $.ajax({ method: "get", url: importBatch.url })
      .done((data) => {
        setImportData(data.quickCaptureImport);
        setLoading(false);
      })
      .fail(() => setLoading(false));
  }, [importBatch.url]);

  if(loading) return <div className="text-center"><Icon name="refresh" /> Loading...</div>;
  if(!importData) return <div className="alert alert-danger">Failed to load import details.</div>;

  return (
    <ul className="list-group">
      {(importData.entries || []).map((e) => {
        const importedClass = {
          imported: "text-success",
          failed: "text-danger",
          working: "text-info",
          queued: "text-muted",
          not_started: "text-muted"
        }[e.importStatus] || "text-muted";

        return (
          <li className="list-group-item" key={e.id}>
            <div>
              <span className={importedClass}>
                <Icon name={e.importStatus === "imported" ? "ok" : (e.importStatus === "failed" ? "remove" : "time")} />
              </span>
              {" "}
              <strong>{e.text.replace(/\{\{|\}\}/g, "")}</strong>
            </div>
            {e.sentence && <div><ClozeSentence text={e.sentence} /></div>}
            {e.sentenceTranslation && <div className="text-muted small">{e.sentenceTranslation}</div>}
            {e.importErrorMessage && <div className="text-danger small">{e.importErrorMessage}</div>}
          </li>
        );
      })}
    </ul>
  );
}

export default function Imports({ importsUrl }) {
  const [loading, setLoading] = useState(true);
  const [imports, setImports] = useState([]);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    $.ajax({ method: "get", url: importsUrl })
      .done((data) => {
        setImports(data.quickCaptureImports || []);
        setLoading(false);
      })
      .fail(() => setLoading(false));
  }, [importsUrl]);

  if(loading) {
    return <div className="text-center"><Icon name="refresh" /> Loading...</div>;
  }

  if(!imports.length) {
    return <p className="text-muted">No imports yet. Select entries and import them to a collection to see them here.</p>;
  }

  return (
    <ul className="list-group">
      {imports.map((imp) => {
        const expanded = expandedId === imp.id;
        const ctx = statusContext(imp.status);

        return (
          <li className="list-group-item" key={imp.id}>
            <div className="row">
              <div className="col-sm-7">
                <span className={`label label-${ctx}`}>{STATUS_LABEL[imp.status] || imp.status}</span>
                {" "}
                <strong>{imp.collectionName || "(unknown collection)"}</strong>
                <div className="text-muted small">{new Date(imp.createdAt).toLocaleString()}</div>
              </div>
              <div className="col-sm-3 small">
                <span className="text-success">Imported: {imp.importedCount || 0}</span>
                {" / "}
                <span className="text-danger">Failed: {imp.failedCount || 0}</span>
                {" / "}
                <span className="text-muted">Total: {imp.selectedCount || 0}</span>
              </div>
              <div className="col-sm-2 text-right">
                <button
                  className="btn btn-default btn-xs"
                  onClick={() => setExpandedId(expanded ? null : imp.id)}
                  type="button"
                >
                  {expanded ? "Hide" : "Details"}
                </button>
              </div>
            </div>
            {expanded && (
              <div style={{ marginTop: 10 }}>
                <ImportDetail importBatch={imp} />
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
